import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Navigation, Thumbs } from "swiper/modules";

Swiper.use([Navigation, Thumbs]);

export default class extends Controller {
  static values = {
    index: { type: Number, default: 0 },
  };

  connect() {
    const thumbEl = this.element.querySelector(".gallery-thumb-swiper-container");
    const mainEl = this.element.querySelector(".gallery-swiper-container");
    if (!thumbEl || !mainEl) return;

    this.thumbSwiper = new Swiper(thumbEl, {
      initialSlide: this.indexValue,
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    this.mainSwiper = new Swiper(mainEl, {
      initialSlide: this.indexValue,
      spaceBetween: 10,
      navigation: {
        nextEl: this.element.querySelector(".gallery-swiper-navigation__next"),
        prevEl: this.element.querySelector(".gallery-swiper-navigation__prev"),
      },
      thumbs: {
        swiper: this.thumbSwiper,
        slideThumbActiveClass: "swiper-slide-thumb-active",
      },
    });
  }

  disconnect() {
    this.mainSwiper?.destroy();
    this.thumbSwiper?.destroy();
  }
}
